<div *ngIf="session" class="w-full lg:max-w-full lg:flex login-page ngIf">
  <div
    class="bg-cover bg-center bg-no-repeat lg:border-l-0 lg:border-t lg:border-gray-400 bg-white rounded-b lg:rounded-b-none lg:rounded-r pt-6 w-full card-form"
    style="
      background-image: url('assets/img/01-BG_AC_Force_N.png');
      background-size: cover;
      background-position: center;
      background-attachment: fixed;
    ">
    <div class="w-4/5 grid-cols-1 flex place-content-center">
      <div class="border-gray-400 lg:border-l-0  lg:border-gray-400 bg-white rounded-b lg:rounded-b-none lg:rounded-r "
        style="opacity: 1">
        <div class="flex justify-center">
          <div
            class="block p-6 bg-[#e3d5b8] border border-gray-200 rounded-lg shadow dark:bg-gray-800 dark:border-gray-700 w-full max-w-4xl">
            <div class="sm:p-2 md:p-10">

              <div id="page-one">
                <div class="flex justify-between mb-10">
                  <div class="logo-icon" style="background-image: url('assets/img/logo_unchk.png')"></div>
                  <div class="logo-icon" style="background-image: url('assets/img/logo_master_card.png')"></div>
                </div>
                <div class="flex justify-center items-center">
                  <!--Classic -->
                  <div class="text-center">
                    <span class="font-bold text-4xl">
                      FORMULAIRE1 DE CANDIDATURE POUR LE MENTORAT
                    </span>

                  </div>
                </div>


                <hr class="h-px my-8 bg-gray-300 border-0 dark:bg-gray-700" />
                <div class="flex justify-center items-center">
                  <div class="text-center pb-3">
                    Les correspondances, les certificats de réussite, l'accès aux plateformes de formation et les badges
                    seront générés à partir des informations personnelles soumises ci-dessous. Veuillez donc fournir des
                    informations correctes et appropriées.
                  </div>
                </div>
              </div>

              <div class="mt-6 sm:mx-auto sm:w-full lg:w-full">
                <form [formGroup]="soumissionForm" class="space-y-6">
                  <div>


                    <div class="grid md:grid-cols-3 m-0 gap-6 my-6">
                      <div class="relative z-0 w-full mb-5 group">
                        <div class="col-span-1 label">
                          <div class="lg:me-3 font-bold text-gray-700 text-sm uppercase">
                            VOUS VOULEZ CANDIDATER POUR QUEL(S) CERTIFICAT(S) ?
                            <span style="color: red">*</span>
                          </div>

                          <div *ngIf="isFieldInvalid('listCertificats')" class="mt-2 font-light text-xs"
                            style="color: #eb1c1c">
                            Champ requis !
                          </div>
                        </div>
                      </div>
                      <div class="col-span-2">
                        <div class="relative z-0 w-full group">
                          <div class="grid grid-cols-1 sm:grid-cols-2 gap-2">
                            <div *ngFor="let certificat of listCertificat; let i = index" class="mb-2">
                              <div class="flex items-center">
                                <input type="checkbox" [id]="'certificat-' + i" [value]="certificat.id"
                                  (change)="onCertificatChange($event)"
                                  class="form-check-input cursor-pointer text-gray-800 font-light"
                                  style="font-size: 0.95rem; line-height: 1.2;">
                                <label [for]="'certificat-' + i" class="ms-2 cursor-pointer text-gray-800 font-light">
                                  {{ certificat.fullname }}</label>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="flex justify-between gap-2 gap-6 my-6">
                      <span class="font-bold text-2xl">I. INFORMATIONS PERSONNELLES</span>
                    </div>
                    <hr class="h-px my-8 bg-gray-300 border-0 dark:bg-gray-700" />

                    <div class="grid md:grid-cols-3 m-0 md:gap-6">
                      <div class="relative z-0 w-full group">
                        <div class="col-span-1 label">
                          <div class="lg:me-3">
                            Prénom - Nom
                            <span style="color: red">*</span>
                          </div>
                          <div *ngIf="
                        isFieldInvalid('firstname') ||
                        isFieldInvalid('lastname')
                      " style="color: #eb1c1c">
                            Champ requis !
                          </div>
                        </div>
                      </div>
                      <div class="relative z-0 w-full group">
                        <input type="text" id="prenom"
                          class="block w-full h-12 rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-800 sm:text-sm sm:leading-6"
                          formControlName="firstname" [style.border]="
                      isFieldInvalid('firstname') ? '2px solid #eb1c1c' : ''
                    " />
                        <div class="mt-1 text-sm">
                          <p>Prénom</p>
                        </div>
                      </div>
                      <div class="relative z-0 w-full group">
                        <input type="text" id="nom"
                          class="block w-full h-12 rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-800 sm:text-sm sm:leading-6 bg-white"
                          formControlName="lastname" [style.border]="
                      isFieldInvalid('lastname') ? '2px solid #eb1c1c' : ''
                    " />
                        <div class="mt-1 text-sm">
                          <p>Nom</p>
                        </div>
                      </div>
                    </div>
                    <div class="relative">
                      <div class="grid lg:grid-cols-3 gap-6 my-6 mx-0">
                        <div class="relative z-0 w-full group">
                          <div class="col-span-1 label">
                            <div class="lg:me-3">
                              Date de naissance
                              <span style="color: red">*</span>
                            </div>
                            <div *ngIf="isFieldInvalid('selectedDate')" style="color: #eb1c1c">
                              Champ requis !
                            </div>
                            <!-- <div *ngIf="checkValidAge()" style="color: #eb1c1c">
                        L'âge limite de candidature est de 35 ans !
                      </div> -->
                          </div>
                        </div>
                        <div class="col-span-2">
                          <div class="flex justify-between gap-3">
                            <div class="w-full">
                              <input type="date" formControlName="selectedDate" id="year"
                                class="block w-full h-12 rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-800 sm:text-sm sm:leading-6"
                                [style.border]="
                            isFieldInvalid('selectedDate')
                              ? '2px solid #eb1c1c'
                              : ''
                          " />

                              <div class="mt-3">
                                <p class="text-sm">
                                  Saisir votre date de naissance ou vous pouvez
                                  directement selectionner la date dans l'agenda.
                                </p>
                              </div>
                            </div>

                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="relative">
                      <div class="grid lg:grid-cols-3 gap-6 my-6 mx-0">
                        <div class="relative z-0 w-full group">
                          <div class="col-span-1 label">
                            <div class="lg:me-3">
                              Lieu de naissance
                              <span style="color: red">*</span>
                            </div>
                            <div *ngIf="isFieldInvalid('lieu_naissance')" style="color: #eb1c1c">
                              Champ requis !
                            </div>
                          </div>
                        </div>
                        <div class="col-span-2">
                          <div class="flex justify-between gap-3">
                            <div class="w-full">
                              <input type="text" formControlName="lieu_naissance"
                                class="block w-full h-12 rounded-md py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-800 sm:text-sm sm:leading-6"
                                [style.border]="
                            isFieldInvalid('lieu_naissance')
                              ? '2px solid #eb1c1c'
                              : ''
                          " />
                            </div>

                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="grid md:grid-cols-3 m-0 md:gap-6">
                      <div class="relative z-0 w-full mb-5 group">
                        <div class="col-span-1 label">
                          <div class="lg:me-3">
                            Sexe
                            <span style="color: red">*</span>
                          </div>
                          <div *ngIf="isFieldInvalid('selectedSexe')" style="color: #eb1c1c">
                            Champ requis !
                          </div>
                        </div>
                      </div>
                      <div class="relative z-0 w-full mb-5 group">
                        <div class="flex items-center">
                          <input formControlName="selectedSexe" id="bordered-radio" type="radio" value="Homme"
                            name="selectedSexe"
                            class="w-6 h-6 text-blue-600 bg-gray-100 border-gray-300 focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600"
                            [style.border]="
                        isFieldInvalid('selectedSexe')
                          ? '2px solid #eb1c1c'
                          : ''
                      " />
                          <label for="bordered-radio"
                            class="w-full py-4 ms-2 text-sm font-medium text-gray-900 dark:text-gray-300">Masculin</label>
                        </div>
                      </div>
                      <div class="relative z-0 w-full mb-5 group">
                        <div class="flex items-center">
                          <input formControlName="selectedSexe" id="bordered-radio" value="Féminin" type="radio"
                            name="selectedSexe"
                            class="w-6 h-6 text-blue-600 bg-gray-100 border-gray-300 focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600"
                            [style.border]="
                        isFieldInvalid('selectedSexe')
                          ? '2px solid #eb1c1c'
                          : ''
                      " />
                          <label for="bordered-radio"
                            class="w-full py-4 ms-2 text-sm font-medium text-gray-900 dark:text-gray-300">Féminin</label>
                        </div>
                      </div>
                    </div>
                    <div class="grid md:grid-cols-3 m-0 md:gap-6">
                      <div class="relative z-0 w-full group">
                        <div class="col-span-1 label">
                          <div class="lg:me-3">
                            Numéro de téléphone
                            <span style="color: red">*</span>
                          </div>
                          <div *ngIf="
                        isFieldInvalid('phoneNumber') ||
                        isFieldInvalid('phoneCode')
                      " style="color: #eb1c1c">
                            Champ requis !
                          </div>
                          <!-- <div *ngIf="checkValideCallNumber()" style="color: #eb1c1c">
                      Tapez seulement des nombres!
                    </div> -->
                        </div>
                      </div>
                      <div class="relative z-0 w-full group">
                        <select type="text" id="prenom"
                          class="block w-full h-12 rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-800 sm:text-sm sm:leading-6"
                          formControlName="phoneCode" [style.border]="
                      isFieldInvalid('phoneCode') ? '2px solid #eb1c1c' : ''
                    ">
                          <option *ngFor="let phonecode of phoneCode" [value]="phonecode.phoneCode">
                            {{ phonecode.phoneCode }}
                          </option>
                        </select>
                        <div class="mt-1 text-sm">
                          <p>Indicatif pays</p>
                        </div>
                      </div>
                      <div class="relative z-0 w-full group">
                        <input type="tel" id="phoneNumber" placeholder="ex: 221 123456789"
                          class="block w-full h-12 rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-800 sm:text-sm sm:leading-6 bg-white"
                          formControlName="phoneNumber" onlyNumber [style.border]="
                      isFieldInvalid('phoneNumber') ? '2px solid #eb1c1c' : ''
                    " />
                        <div class="mt-1 text-sm">
                          <p>Numéro de téléphone</p>
                        </div>
                      </div>
                    </div>

                    <div class="grid md:grid-cols-3 m-0 gap-6 my-6">
                      <div class="relative z-0 w-full mb-5 group">
                        <div class="col-span-1 label">
                          <div class="lg:me-3">
                            Ce numéro est-il disponible sur <br />
                            Whatsapp&nbsp;?
                            <span style="color: red">*</span>
                          </div>
                          <div *ngIf="isFieldInvalid('isWhatsApp')" style="color: #eb1c1c">
                            Champ requis !
                          </div>
                        </div>
                      </div>
                      <div class="relative z-0 w-full mb-5 group">
                        <div class="flex items-center">
                          <input formControlName="isWhatsApp" id="bordered-radio-1" type="radio" value="OUI"
                            name="isWhatsApp"
                            class="w-6 h-6 text-blue-600 bg-gray-100 border-gray-300 focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600"
                            [style.border]="
                        isFieldInvalid('isWhatsApp') ? '2px solid #eb1c1c' : ''
                      " />
                          <label for="bordered-radio-1"
                            class="w-full py-4 ms-2 text-sm font-medium text-gray-900 dark:text-gray-300">Oui</label>
                        </div>
                      </div>
                      <div class="relative z-0 w-full mb-5 group">
                        <div class="flex items-center">
                          <input formControlName="isWhatsApp" checked id="bordered-radio-1" type="radio" value="NON"
                            name="isWhatsApp"
                            class="w-6 h-6 text-blue-600 bg-gray-100 border-gray-300 focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600"
                            [style.border]="
                        isFieldInvalid('isWhatsApp') ? '2px solid #eb1c1c' : ''
                      " />
                          <label for="bordered-radio-1"
                            class="w-full py-4 ms-2 text-sm font-medium text-gray-900 dark:text-gray-300">Non</label>
                        </div>
                      </div>
                    </div>

                    <div class="grid md:grid-cols-3 m-0 md:gap-6"
                      *ngIf="soumissionForm.get('isWhatsApp')?.value === 'NON'">
                      <div class="relative z-0 w-full group">
                        <div class="col-span-1 label">
                          <div class="lg:me-3">
                            Numéro Whatsapp
                            <span style="color: red">*</span>
                          </div>
                          <div *ngIf="
                        isFieldInvalid('whatsAppNumber') ||
                        isFieldInvalid('phoneCodeForWhatsApp')
                      " style="color: #eb1c1c">
                            Champ requis !
                          </div>
                          <!-- <div *ngIf="checkValideCallNumber()" style="color: #eb1c1c">
                      Tapez seulement des nombres!
                    </div> -->
                        </div>
                      </div>
                      <div class="relative z-0 w-full group">
                        <select type="text" id="prenom"
                          class="block w-full h-12 rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-800 sm:text-sm sm:leading-6"
                          formControlName="phoneCodeForWhatsApp" [style.border]="
                      isFieldInvalid('phoneCodeForWhatsApp')
                        ? '2px solid #eb1c1c'
                        : ''
                    ">
                          <option *ngFor="let phonecode of phoneCodeWhatsapp" [value]="phonecode.phoneCode">
                            {{ phonecode.phoneCode }}
                          </option>
                        </select>
                        <div class="mt-3">
                          <p>Indicatif pays</p>
                        </div>
                      </div>
                      <div class="relative z-0 w-full group">
                        <input type="tel" id="whatsAppNumber"
                          class="block w-full h-12 rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-800 sm:text-sm sm:leading-6 bg-white"
                          formControlName="whatsAppNumber" onlyNumber [style.border]="
                      isFieldInvalid('whatsAppNumber')
                        ? '2px solid #eb1c1c'
                        : ''
                    " />
                        <div class="mt-3">
                          <p>Numéro de téléphone</p>
                        </div>
                      </div>
                    </div>

                    <div formGroupName="emailGroup">
                      <div class="grid md:grid-cols-3 m-0 gap-6 my-6">
                        <div class="relative z-0 w-full mb-5 group">
                          <div class="col-span-1 label">
                            <div class="lg:me-3">
                              Adresse email
                              <span style="color: #ff0000">*</span>
                            </div>

                            <div *ngIf="isFieldInvalidForMails('emailGroup.email')" style="color: #eb1c1c">
                              Champ requis !
                            </div>
                            <div *ngIf="isMailFieldInvalid('email')" style="color: #eb1c1c">
                              Format de l'email invalide.
                            </div>

                          </div>
                        </div>
                        <div class="col-span-2 label">
                          <div class="relative z-0 w-full group">
                            <input type="text" id="email"
                              class="block w-full h-12 rounded-md py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-800 sm:text-sm sm:leading-6"
                              placeholder="Par ex : monemail@exemple.com" formControlName="email" [style.border]="
                          isFieldInvalid('emailGroup.email')
                            ? '2px solid #eb1c1c'
                            : ''
                        " />
                          </div>
                        </div>
                      </div>
                      <div class="grid md:grid-cols-3 m-0 gap-6 mt-6">
                        <div class="relative z-0 w-full mb-5 group">
                          <div class="col-span-1 label">
                            <div class="lg:me-3"></div>
                          </div>

                          <div *ngIf="isFieldInvalidForMails('emailGroup.confirmEmail')" style="color: #eb1c1c">
                            Champ requis !
                          </div>
                          <div *ngIf="isMailFieldInvalid('confirmEmail')" style="color: #eb1c1c">
                            Format de l'email invalide.
                          </div>

                          <div *ngIf="showEmailErrors$ | async" style="color: #eb1c1c">
                            Mettez des mails identiques !
                          </div>
                        </div>
                        <div class="col-span-2 label">
                          <div class="relative z-0 w-full mb-5 group">
                            <input type="email" id="confirmEmail"
                              class="block w-full h-12 rounded-md py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-800 sm:text-sm sm:leading-6"
                              formControlName="confirmEmail" placeholder="Veuillez confirmer votre adresse email"
                              [style.border]="
                          isFieldInvalid('emailGroup.confirmEmail')
                            ? '2px solid #eb1c1c'
                            : ''
                        " />
                            <div class="mt-3">
                              <p class="text-sm">
                                Pour être sûr de bien recevoir nos mails,
                                merci d'utiliser des adresses type Gmail,
                                Evitez les adresses Outlook, Yahoo, Hotmail et professionnelles.
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="relative">
                      <div class="grid lg:grid-cols-3 gap-6 my-6 mx-0">
                        <div class="relative z-0 w-full group">
                          <div class="col-span-1 label">
                            <div class="lg:me-3">
                              Ville de residence
                              <span style="color: red">*</span>
                            </div>
                            <div *ngIf="isFieldInvalid('ville_residence')" style="color: #eb1c1c">
                              Champ requis !
                            </div>
                          </div>
                        </div>
                        <div class="col-span-2">
                          <div class="flex justify-between gap-3">
                            <div class="w-full">
                              <input type="text" formControlName="ville_residence"
                                class="block w-full h-12 rounded-md py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-800 sm:text-sm sm:leading-6"
                                [style.border]="
                            isFieldInvalid('ville_residence')
                              ? '2px solid #eb1c1c'
                              : ''
                          " />
                            </div>

                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="grid md:grid-cols-3 m-0 gap-6 my-6">
                      <div class="relative z-0 w-full mb-5 group">
                        <div class="col-span-1 label">
                          <div class="lg:me-3">
                            Région de résidence
                            <span style="color: red">*</span>
                          </div>
                          <div *ngIf="isFieldInvalid('selectedRegion')" style="color: #eb1c1c">
                            Champ requis !
                          </div>
                        </div>
                      </div>
                      <div class="col-span-2 label">
                        <div class="relative z-0 w-full mb-5 group">
                          <select formControlName="selectedRegion" id="cities"
                            class="bg-white border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                            [style.border]="
                        isFieldInvalid('selectedRegion')
                          ? '2px solid #eb1c1c'
                          : ''
                      ">
                            <option *ngFor="let region of regions" [value]="region.name">
                              {{ region.name }}
                            </option>
                          </select>
                        </div>
                      </div>
                    </div>
                    <div class="grid md:grid-cols-3 m-0 gap-6 my-6">
                      <div class="relative z-0 w-full mb-5 group">
                        <div class="col-span-1 label">
                          <div class="lg:me-3">
                            Pays de résidence
                            <span style="color: red">*</span>
                          </div>
                          <div *ngIf="isFieldInvalid('pays_residence')" style="color: #eb1c1c">
                            Champ requis !
                          </div>
                        </div>
                      </div>
                      <div class="col-span-2 label">
                        <div class="relative z-0 w-full mb-5 group">
                          <select formControlName="pays_residence" id="pays"
                            class="bg-white border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                            [style.border]="
                        isFieldInvalid('pays_residence')
                          ? '2px solid #eb1c1c'
                          : ''
                      ">
                            <option *ngFor="let p of pays" [value]="p.name">
                              {{ p.name }}
                            </option>
                          </select>
                        </div>
                      </div>
                    </div>


                    <div class="flex justify-between gap-2 gap-6 my-6">
                      <span class="font-bold text-2xl">II. SITUATION ACADEMIQUE ET PROFESSIONNELLE</span>
                    </div>
                    <hr class="h-px my-8 bg-gray-300 border-0 dark:bg-gray-700" />

                    <div class="grid md:grid-cols-3 m-0 gap-6 my-6">
                      <div class="relative z-0 w-full mb-5 group">
                        <div class="col-span-1 label">
                          <div class="lg:me-3 font-bold text-[#444] text-sm uppercase">
                            Quel est votre statut actuel ?
                            <span style="color: red">*</span>
                          </div>
                          <div *ngIf="isFieldInvalid('professionnalSituation')" class="text-xs font-light mt-1"
                            style="color: #eb1c1c">
                            Champ requis !
                          </div>
                        </div>
                      </div>

                      <div class="col-span-2">
                        <div class="relative z-0 w-full group">
                          <div class="grid grid-cols-1 sm:grid-cols-2 gap-2">

                            <div *ngFor="let statut of statut_actuel; let i = index" class="mb-2">
                              <div class="flex items-center">
                                <input type="checkbox" [id]="'statut-' + i" [value]="statut"
                                  (change)="onCheckboxChange($event, statut)" class="form-check-input cursor-pointer"
                                  style="width: 20px; height: 20px; border: 1px solid #999;">
                                <label [for]="'statut-' + i" class="ms-2 cursor-pointer text-gray-800 font-light"
                                  style="font-size: 0.95rem; line-height: 1.2;">
                                  {{ statut }}
                                </label>
                              </div>
                            </div>

                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="grid md:grid-cols-3 m-0 gap-6 my-6">
                      <div class="relative z-0 w-full mb-5 group">
                        <div class="col-span-1 label">
                          <div class="lg:me-3">
                            Niveau de formation (indiquer le niveau le plus élevé obtenu) &nbsp;
                            <span style="color: red">*</span>
                          </div>
                          <div *ngIf="isFieldInvalid('selectedDiplome')" style="color: #eb1c1c">
                            Champ requis !
                          </div>
                        </div>
                      </div>
                      <div class="col-span-2 label">
                        <div class="relative z-0 w-full mb-5 group">
                          <select formControlName="selectedDiplome" id="countries"
                            class="bg-white border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                            [style.border]="
                        isFieldInvalid('selectedDiplome')
                          ? '2px solid #eb1c1c'
                          : ''
                      ">
                            <option *ngFor="let diplome of diplomes" [value]="diplome.name">
                              {{ diplome.name }}
                            </option>
                          </select>
                        </div>
                      </div>
                    </div>

                    <div class="flex justify-between gap-2 gap-6 my-6">
                      <span class="font-bold text-2xl">III. EXPÉRIENCE DANS LA FORMATION EN LIGNE ET DANS LE
                        MENTORAT</span>
                    </div>
                    <hr class="h-px my-8 bg-gray-300 border-0 dark:bg-gray-700" />

                    <div class="grid md:grid-cols-3 m-0 gap-6 my-6">
                      <div class="relative z-0 w-full mb-5 group">
                        <div class="col-span-1 label">
                          <div class="lg:me-3">
                            Avez-vous déjà une expérience dans la formation en ligne ?
                            <span style="color: red">*</span>
                          </div>
                          <div *ngIf="isFieldInvalid('onlineAcademyExprience')" style="color: #eb1c1c">
                            Champ requis !
                          </div>
                        </div>
                      </div>

                      <div class="col-span-2 label">
                        <div class="relative z-0 w-full mb-5 group">
                          <select formControlName="onlineAcademyExprience" id="onlineAcademyExprience" class="bg-white border border-gray-300 text-gray-900 text-sm rounded-lg
                                    focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5
                                    dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400
                                    dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                            [style.border]="
                                isFieldInvalid('onlineAcademyExprience')
                                  ? '2px solid #eb1c1c'
                                  : ''
                              ">
                            <option [ngValue]="null" disabled>-- Sélectionnez --</option>
                            <option [ngValue]="true">Oui</option>
                            <option [ngValue]="false">Non</option>
                          </select>
                        </div>
                      </div>
                    </div>

                    <div class="grid lg:grid-cols-3 gap-6 my-6 mx-0"
                      *ngIf="soumissionForm.get('onlineAcademyExprience')?.value === true">
                      <div class="relative z-0 w-full mb-5 group">
                        <div class="col-span-1 label">
                          <div class="lg:me-3">
                            Décrivez en quelques phrases votre expérience dans la formation en ligne (au maximum 1.500
                            caractères, espaces compris)
                            <span style="color: red">*</span>
                          </div>
                          <div *ngIf="isFieldInvalid('desc_experience')" style="color: #eb1c1c">
                            Champ requis !
                          </div>
                        </div>
                      </div>
                      <div class="col-span-2">
                        <textarea formControlName="desc_experience" id="desc_experience" rows="5"
                          class="bg-white border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                          [style.border]="
                      isFieldInvalid('desc_experience') ? '2px solid #eb1c1c' : ''
                    ">></textarea>

                      </div>
                    </div>

                    <div class="grid lg:grid-cols-3 gap-6 my-6 mx-0">
                      <div class="relative z-0 w-full mb-5 group">
                        <div class="col-span-1 label">
                          <div class="lg:me-3">
                            Avez-vous déjà une expérience dans le mentorat ?
                            <span style="color: red">*</span>
                          </div>
                          <div *ngIf="isFieldInvalid('experience_mentorat')" style="color: #eb1c1c">
                            Champ requis !
                          </div>
                        </div>
                      </div>

                      <div class="col-span-2">
                        <select formControlName="experience_mentorat" id="experience_mentorat" class="bg-white border border-gray-300 text-gray-900 text-sm rounded-lg
                                  focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5
                                  dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400
                                  dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500" [style.border]="
                              isFieldInvalid('experience_mentorat')
                                ? '2px solid #eb1c1c'
                                : ''
                            ">
                          <option [ngValue]="null" disabled>-- Sélectionnez --</option>
                          <option [ngValue]="true">Oui</option>
                          <option [ngValue]="false">Non</option>
                        </select>
                      </div>
                    </div>
                    <div class="grid lg:grid-cols-3 gap-6 my-6 mx-0"
                      *ngIf="soumissionForm.get('experience_mentorat')?.value === true">
                      <div class="relative z-0 w-full mb-5 group">
                        <div class="col-span-1 label">
                          <div class="lg:me-3">
                            Décrivez en quelques phrases votre expérience dans le mentorat (au maximum 1.500 caractères,
                            espaces compris)
                            <span style="color: red">*</span>
                          </div>
                          <div *ngIf="isFieldInvalid('desc_phase_mentorat')" style="color: #eb1c1c">
                            Champ requis !
                          </div>
                        </div>
                      </div>
                      <div class="col-span-2">
                        <textarea formControlName="desc_phase_mentorat" id="desc_phase_mentorat" rows="5"
                          class="bg-white border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                          [style.border]="
                      isFieldInvalid('desc_phase_mentorat') ? '2px solid #eb1c1c' : ''
                    ">></textarea>

                      </div>
                    </div>
                    <div class="justify-between gap-2 gap-6 my-6">
                      <p class="font-bold text-2xl">IV. FICHIERS À JOINDRE AU DOSSIER DE CANDIDATURE</p>
                      <span class="text-xs">
                        Joindre CV (CV complet et actualisé, avec mention des références professionnelles) - LETTRE DE
                        MOTIVATION - COPIES DES DIPLÔMES ET/OU DES ATTESTATIONS PROFESSIONNELLES <span
                          style="color: red">*</span>
                      </span>

                    </div>
                    <hr class="h-px my-8 bg-gray-300 border-0 dark:bg-gray-700" />
                    <div class="grid md:grid-cols-3 m-0 md:gap-10 items-start p-6">
                      <div class="label font-bold text-[#374151] text-lg uppercase">
                        <!-- VOTRE CURRICULUM VITAE (CV) <span class="text-red-600">*</span> -->
                      </div>

                      <div class="w-full col-span-2">
                        <div (click)="fileInput.click()" [ngClass]="{
                            'border-red-500': isFieldInvalid('fileSource'),
                            'border-gray-400': !isFieldInvalid('fileSource')
                          }"
                          class="border-2 border-dashed border-gray-400 rounded-md p-8 bg-white flex flex-col items-center justify-center cursor-pointer hover:bg-gray-50 transition-all shadow-sm">
                          <input type="file" #fileInput class="hidden" (change)="onFileChange($event)"
                            accept=".pdf,.doc,.docx,.text-xl,.xlsx" multiple>
                          <svg class="w-14 h-14 text-[#94a3b8] mb-2" fill="currentColor" viewBox="0 0 24 24">
                            <path
                              d="M19.35 10.04A7.49 7.49 0 0012 4C9.11 4 6.6 5.64 5.35 8.04A5.994 5.994 0 000 14c0 3.31 2.69 6 6 6h13c2.76 0 5-2.24 5-5 0-2.64-2.05-4.78-4.65-4.96zM14 13v4h-4v-4H7l5-5 5 5h-3z" />
                          </svg>

                          <span class="text-[#2d3748] text-xl font-bold">Parcourir les fichiers</span>
                          <span class="text-[#64748b] text-sm mt-1">Glissez-déposez des fichiers ici</span>
                        </div>
                        <div *ngFor="let file of soumissionForm.get('fileSource')?.value || []; let i = index">
                          {{ file.name }}
                          <button type="button" (click)="removeFile(i)">❌</button>
                        </div>

                        <p class="text-[#4b5563] text-sm mt-2 font-medium">
                          Chaque fichier ne doit pas dépasser 2MO
                        </p>

                        <p class="text-red-600 text-sm" *ngIf="soumissionForm.get('fileSource')?.touched
                                && soumissionForm.get('fileSource')?.invalid">
                          Veuillez sélectionner au moins un fichier
                        </p>

                        <p class="text-red-600 text-sm" *ngIf="badSize">
                          le fichier ne doit pas depasser 2MO
                        </p>
                      </div>
                    </div>
                    <div class="grid lg:grid-cols-3 gap-6 my-6 mx-0">
                      <div class="relative z-0 w-full mb-5 group">
                        <div class="col-span-1 label">
                          <div class="lg:me-3">
                            Indiquez ici, si vous le souhaitez, toute information vous concernant et que vous
                            souhaiteriez partager avec le comité de sélection (au maximum 1.500
                            caractères, espaces compris)

                          </div>

                        </div>
                      </div>
                      <div class="col-span-2">
                        <textarea formControlName="plus_detail" id="plus_detail" rows="5"
                          class="bg-white border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"></textarea>
                      </div>
                    </div>

                    <hr class="h-1 my-8 bg-green-500 border-0 dark:bg-gray-700" />

                    <div class="flex justify-center items-center" *ngIf="isSucces" style="color: #23eb1c">
                      Candidature reussie!
                    </div>

                    <div class="flex justify-center items-center" *ngIf="soumissionForm.invalid"
                      style="color: hwb(0 11% 8%)">
                      Merci de renseigner tous les champs requis!
                    </div>


                    <div class="flex justify-center mt-4">
                      <button type="button" [disabled]="isLoading"
                        class="rounded-md w-48 h-12 px-3 py-2 text-sm font-semibold leading-6 text-white shadow-sm button-orange-500 disabled:opacity-50 disabled:cursor-not-allowed flex items-center justify-center gap-2"
                        (click)="onSubmit()">

                        <span *ngIf="!isLoading">VALIDER</span>

                        <span *ngIf="isLoading" class="flex items-center gap-2">
                          <svg class="animate-spin h-5 w-5 text-white" viewBox="0 0 24 24">
                            <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4">
                            </circle>
                            <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v8H4z"></path>
                          </svg>
                          Envoi...
                        </span>

                      </button>
                    </div>

                    <div class="flex justify-center mt-8">
                      <div class="logo-icon" style="background-image: url('assets/img/logo_force_n.png')"></div>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>


    </div>
  </div>
</div>


<div *ngIf="isLoading" class="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">

  <div class="bg-white p-6 rounded-lg shadow-lg flex flex-col items-center gap-4">

    <svg class="animate-spin h-10 w-10 text-orange-500" viewBox="0 0 24 24">
      <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
      <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v8H4z"></path>
    </svg>

    <span class="text-gray-700 font-semibold">
      Soumission en cours...
    </span>

  </div>
</div>



<div *ngIf="noSession" class="bg-cover bg-center h-screen w-screen"
  style="background-image: url('assets/img/01-BG_AC_Force_N.png')">
  <div class="h-full w-full flex items-center justify-center bg-black bg-opacity-50">
    <div
      class="overflow-y-auto overflow-x-hidden fixed z-50 justify-center items-center w-full md:inset-0 h-[calc(100%-1rem)] max-h-full flex">
      <div class="relative p-4 w-full max-w-md max-h-full">
        <div class="relative bg-white rounded-lg shadow dark:bg-gray-700">
          <div class="p-4 md:p-5 text-center">
            <svg class="mx-auto mb-4 text-gray-400 w-12 h-12 dark:text-gray-200" aria-hidden="true"
              xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 20 20">
              <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                d="M10 11V6m0 8h.01M19 10a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z" />
            </svg>
            <h3 class="mb-5 text-lg font-normal text-gray-500 dark:text-gray-400">
              Les candidatures sont closes pour cette session. Restez en contact
              avec nous sur
              <a style="color: blue" href="https://force-n.sn/">https://force-n.sn/</a>
            </h3>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>